(() => {
  function fadeInImage(image) {
    image.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
    image.style.visibility = 'visible';
    image.style.opacity = 1;
  }

  function closeOthers(target) {
    target.closest('.custom-feature-accordion')?.querySelectorAll('details').forEach((detail) => {
      if (detail !== target) {
        detail.removeAttribute('open');
      }
    });
  }

  function updateImage(target) {
    const section = target.closest('.custom-feature-accordion');
    const featuredImage = section?.querySelector('.custom-feature-accordion__image--featured');
    const newImage = target.querySelector('.custom-feature-accordion__image img');

    if (!featuredImage || !newImage || featuredImage.src === newImage.src) {
      return;
    }

    featuredImage.style.opacity = 0;
    featuredImage.style.visibility = 'hidden';

    setTimeout(() => {
      featuredImage.onload = () => {
        fadeInImage(featuredImage);
        featuredImage.onload = null;
      };
      
      featuredImage.src = newImage.src;
      featuredImage.alt = newImage.alt;
    }, 300);
  }

  function handleClick(evt) {
    const target = evt.currentTarget;
    closeOthers(target);
    updateImage(target);
  }

  document.querySelectorAll('.custom-feature-accordion:not([initialized])').forEach((section) => {
    section.setAttribute('initialized', 'true');
    const details = section.querySelectorAll('details');

    details.forEach((detail, index) => {
      detail.addEventListener('click', handleClick);

      if (index === 0) {
        detail.setAttribute('open', '');
        updateImage(detail);
      }
    });
  });
})();